// ssc-menu.js — Menu + recherche overlay Sunday Sleep Club
(function () {
  const menu = document.getElementById('ssc-menu');
  const backdrop = document.getElementById('ssc-menu-backdrop');
  const search = document.getElementById('ssc-search');
  const searchBackdrop = document.getElementById('ssc-search-backdrop');

  function openMenu() {
    if (!menu || !backdrop) return;
    closeSearch();
    menu.removeAttribute('hidden');
    backdrop.removeAttribute('hidden');
    document.body.style.overflow = 'hidden';
  }

  function closeMenu() {
    if (!menu || !backdrop) return;
    menu.setAttribute('hidden', '');
    backdrop.setAttribute('hidden', '');
    document.querySelectorAll('[data-submenu-toggle]').forEach(function (toggle) {
      toggle.setAttribute('aria-expanded', 'false');
    });
    document.querySelectorAll('.ssc-menu-overlay__submenu').forEach(function (submenu) {
      submenu.setAttribute('hidden', '');
    });
    if (!search || search.hasAttribute('hidden')) {
      document.body.style.overflow = '';
    }
  }

  function openSearch() {
    if (!search) {
      window.location.href = '/search';
      return;
    }
    closeMenu();
    search.removeAttribute('hidden');
    if (searchBackdrop) searchBackdrop.removeAttribute('hidden');
    document.body.style.overflow = 'hidden';
    var input = search.querySelector('.ssc-search-overlay__input');
    if (input) {
      setTimeout(function () {
        input.focus();
      }, 50);
    }
  }

  function closeSearch() {
    if (!search) return;
    search.setAttribute('hidden', '');
    if (searchBackdrop) searchBackdrop.setAttribute('hidden', '');
    if (!menu || menu.hasAttribute('hidden')) {
      document.body.style.overflow = '';
    }
  }

  document.querySelectorAll('[data-action="open-menu"]').forEach(function (btn) {
    btn.addEventListener('click', openMenu);
  });
  document.querySelectorAll('[data-action="close-menu"]').forEach(function (btn) {
    btn.addEventListener('click', closeMenu);
  });
  document.querySelectorAll('[data-action="open-search"]').forEach(function (btn) {
    btn.addEventListener('click', function (e) {
      e.preventDefault();
      openSearch();
    });
  });
  document.querySelectorAll('[data-action="close-search"]').forEach(function (btn) {
    btn.addEventListener('click', closeSearch);
  });
  document.querySelectorAll('[data-submenu-toggle]').forEach(function (toggle) {
    toggle.addEventListener('click', function () {
      const expanded = this.getAttribute('aria-expanded') === 'true';
      const targetId = this.getAttribute('aria-controls');
      const submenu = targetId ? document.getElementById(targetId) : null;
      if (!submenu) return;
      this.setAttribute('aria-expanded', String(!expanded));
      if (expanded) {
        submenu.setAttribute('hidden', '');
      } else {
        submenu.removeAttribute('hidden');
      }
    });
  });
  if (backdrop) backdrop.addEventListener('click', closeMenu);
  if (searchBackdrop) searchBackdrop.addEventListener('click', closeSearch);
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') {
      closeMenu();
      closeSearch();
    }
  });
})();
